import { SearchPipe } from './search.pipe';
import { NgModule } from '@angular/core';
import { OrderByPipe } from './order-by.pipe';
import { IndianNumberPipe } from './indian-number.pipe';

@NgModule({
  declarations: [ SearchPipe, OrderByPipe, IndianNumberPipe ],
  exports: [ SearchPipe, OrderByPipe, IndianNumberPipe  ]
})
export class MyPipesModule {}
